'use strict';

angular.module('atex.dam').factory('DamSearchService', ['DamService', 'SearchService', '$state', '$rootScope', '$timeout', 'DamMarkAsService', '$translate', 'configuration', 'DamStatusService', '$q',
function(DamService, SearchService, $state, $rootScope, $timeout, DamMarkAsService, $translate, configuration, DamStatusService, $q) {

  var currentAdvQuery = {}; // This is the model for the advanced query dialog

  var dynQueryStartTs = {}; // Holds for each dyn query (key is damid) the modification/creation timestamp after which we need to mark qitems as new

  $rootScope.$on("dam:clearCurrentQuery", function() {
    currentAdvQuery = {};
  });

  var _query = {
    set: {
      "physicalPage_ss": "true",
      "tag_dimension.partition_ss": [{
        "id": "production",
        "label": "__PRODUCTION_PARTITION__",
        "icon": "fa fa-globe",
        "icon-color": "black"
      }],
      "atex_desk_objectType": [{
        "id": "page",
        "label": "__PAGE_LABEL__",
        "icon": "fa fa-file"
      }]
    },
    "isDynamic": "false",
    "viewMode": "physical-page",
    "sortValue": "pageSequence_atex_desk_i",
    "sortOrderValue": "asc"
  };

  var currentPhysicalPagesQuery = angular.copy(_query);
  var refreshSearch;
  var lastExtraInfo;
  var advQueryData;

  var facets = [];
  var facetFilterQuery = {};
  var facetSettings;

  var facetFilterQueryString = '';

  // The lastQueryStartTs is set when a simpleSearch / advancedSearch / savedSearch / folderListing starts
  // And is checked to know if the action must be stopped because a new action has started [max]
  var lastQueryStartTs;
  var _setLastQueryStartTs = function (ts) {
    lastQueryStartTs = ts;
  };
  var _isStillLastQuery = function (ts) {
    return lastQueryStartTs === ts;
  };

  // Load MarkAs cfg
  var markAsColors = [];
  var markAsMicons = [];
  var markAsIcons = [];

  $rootScope.$on("dam:loadConfigurationEnd", function () {
    DamMarkAsService.loadColors().then(function (colors) {
      markAsColors = colors;
    });
    DamMarkAsService.loadMultiIcons().then(function (micons) {
      markAsMicons = micons;
    });
    DamMarkAsService.loadIcons().then(function (icons) {
      markAsIcons = icons;
    });
  });

  // Load Status List
  var statusList = [];
  DamStatusService.getStatusList().then(function (status) {
    statusList = status;
  });

  // Load web status List
  var webStatusList = [];
  DamStatusService.getWebStatusList().then(function (status) {
    webStatusList = status;
  });

  // Load attributes List
  var attributesList = [];
  DamStatusService.getAttributesList().then(function (attributes) {
    attributesList = attributes;
  });

  var clearCurrentAdvQuery = function () {
    resetFaceting();
    emptyObject(currentAdvQuery);
    emptyObject(dynQueryStartTs);
    refreshSearch = undefined;
    lastExtraInfo = undefined;
  };

  $rootScope.$on("dam:logout", function () {
    clearCurrentAdvQuery();
  });

  var emptyObject = function (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        delete obj[prop];
      }
    }
  };

  var resetFaceting = function () {
    facets.length = 0;
    emptyObject(facetFilterQuery);
    facetFilterQueryString = '';
  };

  var _setAdvSearchData = function (searchResponseData, queryData, skipUpdAdvSearchDlg) {
    if (!skipUpdAdvSearchDlg) {
      angular.copy(searchResponseData.container.aspects.contentData.data, currentAdvQuery);
    }
    // set query parameter to be used in refresh for advanced
    refreshSearch = searchResponseData;
    if (queryData) {
      advQueryData = queryData;
    }
  };

  var _initFaceting = function (searchResponseData) {
    if (searchResponseData !== undefined) {
      facets.length = 0;
      _addFaceting(searchResponseData, false);
    }
  };

  var updateSearchRemovingContents = function (contentIds) {
    if (!contentIds || contentIds.length === 0) {
      return;
    }

    return DamService.getSolrServerInfo().then(function (solrInfo) {
      var transferInfo = {};
      if (solrInfo.solrLatestCore && advQueryData.onlyLatest) {
        transferInfo['core'] = solrInfo.solrLatestCore;
      } else {
        transferInfo['core'] = solrInfo.solrCore;
      }

      transferInfo['variant'] = 'list';
      transferInfo['fl'] = 'id';
      transferInfo['q'] = advQueryData.solr_query;
      transferInfo['fq'] = '+id:("' + contentIds.join('","') + '")';
      transferInfo['sort'] = "atex_desk_version desc";
      return SearchService.search(transferInfo).then(function (response) {
        var filteredIds = response.data.response.docs.map(function (doc) {
          return doc.id;
        });
        var idsToRemove = contentIds.filter(function (id) {
          return !filteredIds.includes(id);
        });
        if (idsToRemove.length > 0) {
          $rootScope.$broadcast("dam:searchRemovedItems", idsToRemove);
        }
      });
    });
  };

  var updateSearchWithNewContents = function () {
    var tsFilter = '+atex_desk_version:[' + $rootScope.dynamicQueries[refreshSearch.damid] + ' TO *]';
    if (configuration.getOnlyNewInDynQuery() && refreshSearch.container.aspects.contentData.data.physicalPages !== "true") {
      var time = atex.dam.AngularUtils.toUTCDate($rootScope.dynamicQueriesEx[refreshSearch.damid]);
      tsFilter += '+originalCreationTime_dt:[' + time + ' TO *]';
    }
    tsFilter += facetFilterQueryString; // Filter by faceting
    //in case we have a folder search, add the filter to update the results
    if (lastExtraInfo && lastExtraInfo.advancedAsFolderFilter) {
      tsFilter += lastExtraInfo.advancedAsFolderFilter;
    }
    return DamService.updateResults(advQueryData, 0, tsFilter).then(function (response) {
      response.data.damid = refreshSearch.damid;
      response.data.container = refreshSearch.container;
      if (response && response.data.response.numFound > 0) {
        var nextVersion = bigInt(response.data.response.docs[0].atex_desk_version).add(1).toString();
        $rootScope.dynamicQueries[refreshSearch.damid] = nextVersion;
        $rootScope.dynamicQueriesEx[refreshSearch.damid] = response.data.response.docs[0]._data.meta.originalCreationTime;
      }
      if (response.data.response.docs) {
        response.data.response.docs.reverse();
      }
      $rootScope.$broadcast("dam:searchNewItems", response.data);
    });
  };

  var querying4New = false;
  var _updateSearch = function (contentIds) {
    if (querying4New || typeof refreshSearch === 'undefined' || typeof refreshSearch.damid === 'undefined' ||
      refreshSearch.container.aspects.contentData.data.isDynamic !== 'true') {
      return $q.when();
    }

    querying4New = true;
    return $timeout(function () {
      return updateSearchRemovingContents(contentIds)
        .then(function (_) {
          return updateSearchWithNewContents();
        })
        .catch(function (error) {
          console.log('ERROR: Performing updateSearch:', error);
        })
        .finally(function () {
          querying4New = false;
        });
    });
  };

  var fullText = function (queryString, extraInfo) {
    $rootScope.$broadcast("dam:loading-facet:start");
    DamService.getFullText(queryString, 0).then(function (response) {
      if (extraInfo && !_isStillLastQuery(extraInfo.queryTs)) {
        return $q.reject();
      }
      response.data.isFullText = true;
      response.data.searchvalue = queryString;
      $state.go('list');
      $rootScope.$broadcast("dam:search", response.data);
      requestFaceting({"solr_query": DamService.getFullTextQuery(queryString)}, undefined, extraInfo, false, true);
      /*
      DamService.getFacetsValues({"solr_query": DamService.getFullTextQuery(queryString)}).then(function (facetResults) {
        doFaceting(facetResults.data);
        DamService.getFullTextFacets(queryString).then(function (facetResults) {
          if (extraInfo && !_isStillLastQuery(extraInfo.queryTs)) {
            return $q.reject();
          }
          faceting(facetResults.data, true);
          $rootScope.$broadcast("dam:loading-facet:stop");
        }).then(null, function (error) {
          console.log('ERROR: Performing facet query:', error);
          $rootScope.$broadcast("dam:loading-facet:stop");
        });
      }).then(null, function (error) {
        console.log('ERROR: Performing facet query:', error);
        $rootScope.$broadcast("dam:loading-facet:stop");
      });

      */
    });
  };

  function formatDate(date) {
    moment.tz.setDefault("UTC");
    return moment(date.toUTCString()).format('DD/MM/YYYY');
  }

  function getNextDate() {
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  }

  var calcPhysicalPagesQueryName = function (query) {
    var name = $translate.getTranslationTable()._PAGES_ + "-";
    var todayStr = $translate.getTranslationTable().__PH_PAGE_TODAY__;
    var nextStr = $translate.getTranslationTable().__PH_PAGE_NEXT_PUB_DATE__;
    if (query !== undefined) {
      _.each(['publication_atex_desk_ss', 'edition_atex_desk_ss', 'section_atex_desk_ss', 'page_atex_desk_ss', 'pubdate_atex_desk_ss'], function (id) {
        var _field = query.fields.find(function (field) {
          return field.key === id;
        });

        if (_field) {
          if (_field.values) {
            var _value = _field.values[0];
            if (_value) {
              if (_field.type === "PRINT-DATE") {
                if ("TODAY" === _value) {
                  _value = todayStr;
                } else if ("NEXT" === _value) {
                  _value = nextStr;
                } else {
                  _value = formatDate(new Date(_value));
                }
              }
              name += _value.toUpperCase() + "-";
            }
          }
        }
      });
    }

    return name.slice(0, -1);
  };

  var calcQueryName = function (query) {
    var name = "";
    if (query !== undefined) {
      if (query.fullText) {
        name += (name === "") ? query.fullText : ("-" + query.fullText);
      } else if (query.fields) {
        var table = $translate.getTranslationTable();
        var fullTextField = query.fields.find(function (field) {
          return field.key === 'atex_desk_text';
        });
        if (fullTextField && fullTextField.values && fullTextField.values[0]) {
          var fullTextOperatorMsg = (fullTextField.operator) ? table['__NOT_OPERATOR_TXT__'] : "";
          name += (name === "") ? (fullTextOperatorMsg + fullTextField.values[0]) : ("-" + fullTextOperatorMsg + fullTextField.values[0]);
        }
        var typesField = query.fields.find(function (field) {
          return field.key === 'atex_desk_objectType';
        });
        if (typesField) {
          if (typesField.values !== undefined && typesField.values.length === 1) {
            var typesOperatorMsg = (typesField.operator) ? table['__NOT_OPERATOR_TYPE__'] : "";
            var typeValue = typesField.values[0];
            var typeTranslated = table['__' + typeValue.toUpperCase() + '_LABEL__'];
            name += (name === "") ? (typesOperatorMsg + typeTranslated) : ("-" + typesOperatorMsg + typeTranslated);
          }
        }
        var partitionsField = query.fields.find(function (field) {
          return field.key === 'tag_dimension.partition_ss';
        });
        if (partitionsField) {
          if (partitionsField.values !== undefined && partitionsField.values.length === 1) {
            var partitionOperatorMsg = (partitionsField.operator) ? table['__NOT_OPERATOR_PARTITION__'] : "";
            var partitionValue = partitionsField.values[0];
            var partitionTranslated = table['__' + partitionValue.toUpperCase() + '_PARTITION__'];
            name += (name === "") ? (partitionOperatorMsg + partitionTranslated) : ("-" + partitionOperatorMsg + partitionTranslated);
          }
        }
      }
    }
    return name;
  };


  var calcQueryNameBudget = function (query) {
    var name = "";
    if (query !== undefined) {
      if (query.fullText !== undefined) {
        name += (name === "") ? query.fullText : ("-" + query.fullText);
      }
      if (query.headlines !== undefined) {
        name += (name === "") ? query.headlines : ("-" + query.headlines);
      }
      if (query.types !== undefined && query.types.length===1) {
        name += (name === "") ? query.types[0] : ("-" + query.types[0]);
      }
      if (query.partitions !== undefined && query.partitions.length===1) {
        name += (name === "") ? query.partitions[0] : ("-" + query.partitions[0]);
      }
      if (query.assignees !== undefined && query.assignees.length===1) {
        var assignee = query.assignees[0];
        /*if(assignee === "%%CURRENT-USER%%") {
          assignee = localize.getLocalizedString('__CURRENT_USER__');
          assignee = assignee.replace(/ /g,"-");
          assignee = assignee.toLowerCase();
        }*/
        name += (name === "") ? assignee : ("-" + assignee);
      }
      if (query.publications !== undefined && query.publications.length===1) {
        name += (name === "") ? query.publications[0] : ("-" + query.publications[0]);
      }
      if (query.editions !== undefined && query.editions.length===1) {
        name += (name === "") ? query.editions[0] : ("-" + query.editions[0]);
      }
    }
    return name;
  };

  function getMaxSolrVersion(responseDocs) {
    var maxVers = bigInt(0);
    (responseDocs || []).forEach(function (doc) {
      var _currVers = bigInt(doc.atex_desk_version);
      if (_currVers.greater(maxVers)) {
        maxVers = _currVers;
      }
    });
    return maxVers;
  }

  var _runQueryContainer = function (queryContainer, extraInfo) {
    var advancedAsFolderFilter;
    var fullTextField;
    var headlineTextField;
    var oldFullTextValue;
    var oldHeadlineTextValue;
    var originalQueryValues = angular.copy(queryContainer);
    // For now let's only check if it's a folder listing and in that case set always the query as a all archive query!
    // In the future we need to add the 'allArchive' checkbox also in the folder dialog creation/modification
    // in order to choose if we want all or latest results [max]
    var listingFolder = extraInfo && (extraInfo.type === 'atex.dam.standard.Folder' || extraInfo.type === 'webSection');

    if (listingFolder && configuration.getQueryTermsInAnd()) {
      // normalizeQueryString for simple search refine in listingFolder
      var _fullText = atex.onecms.ObjectUtils.getByPath(queryContainer, 'container/aspects/contentData/data/fullText');
      if (_fullText) {
        queryContainer.container.aspects.contentData.data.fullText = DamService.normalizeQueryString(_fullText);
      }
    }

    if ( queryContainer.container.aspects.contentData.data ) {
      var removeList = ["values", "clearValues", "readOnly", "forPrint"];
      var data = queryContainer.container.aspects.contentData.data;

      removeList.forEach(function( member ) {
        if ( data[member] ) {
          delete data[member];
        }
      });
     }

    if (extraInfo && extraInfo.advancedAsFolderFilter) {
      // We have filter query, we are refining folder with advanced search [max]
      advancedAsFolderFilter = extraInfo.advancedAsFolderFilter;
    } else {
      // Real advanced
      var stringTextField = _.filter(queryContainer.container.aspects.contentData.data.fields, function (field) {
        return field.type === "STRING";
      });
      if (configuration.getQueryTermsInAnd()) {
        stringTextField.forEach(function (field) {
          field.values[0] = DamService.normalizeQueryString(field.values[0], undefined, field.queryOperator);
          if (field.key === 'atex_desk_text' && queryContainer.container.aspects.contentData.data.fullText) {
            queryContainer.container.aspects.contentData.data.fullText =
              DamService.normalizeQueryString(queryContainer.container.aspects.contentData.data.fullText, undefined, field.queryOperator);
          }
        });
      } else {
        stringTextField.forEach(function (field) {
          if (field.key === 'id') {
            field.values[0] = DamService.escapeLucene(field.values[0].trim());
          }
        });
      }
    }

    lastExtraInfo = extraInfo;
    resetFaceting();
    $rootScope.$broadcast("dam:initSearch", extraInfo);
    $state.go('list');
    var damid = queryContainer.damid;
    var sortValue = queryContainer.container.aspects.contentData.data.sortValue;
    var sortOrderValue = queryContainer.container.aspects.contentData.data.sortOrderValue;
    DamService.getQuery(queryContainer.container).then(function (queryData) {
      if (extraInfo && !_isStillLastQuery(extraInfo.queryTs)) {
        return $q.reject();
      }
      queryData.data.isDynamic = queryContainer.container.aspects.contentData.data.isDynamic;
      queryData.data.includeTrash = queryContainer.container.aspects.contentData.data.includeTrash;
      $rootScope.$broadcast("dam:loading-facet:start");
      DamService.getSolrServerInfo().then(function (solrInfo) {
        queryData.data.physicalPages = queryContainer.container.aspects.contentData.data.physicalPages;
        if (solrInfo.solrLatestCore && solrInfo.solrLatestCore !== solrInfo.solrCore) {
          queryData.data.onlyLatest = !listingFolder && queryContainer.container.aspects.contentData.data.allArchive !== "true" && queryData.data.physicalPages !== "true";
        }
        queryData.data.budgetView = queryContainer.container.aspects.contentData.data.budgetView;
        DamService.getResults(queryData.data, 0, advancedAsFolderFilter, sortValue, sortOrderValue).then(function (response) {

          if (configuration.getQueryTermsInAnd()) {
            if (stringTextField instanceof Array) {
              stringTextField.forEach(function (field) {
                var originalFieldValue = _.find(originalQueryValues.container.aspects.contentData.data.fields, function (originalField) {
                  return originalField.key === field.key;
                });
                if (originalFieldValue.values !== field.values) {
                  field.values = originalFieldValue.values;
                }
              });
            }
            if (queryContainer.container.aspects.contentData.data.fullText !== originalQueryValues.container.aspects.contentData.data.fullText){
              queryContainer.container.aspects.contentData.data.fullText = originalQueryValues.container.aspects.contentData.data.fullText;
            }
          }

          if (extraInfo && !_isStillLastQuery(extraInfo.queryTs)) {
            return $q.reject();
          }
          $rootScope.lastSearch = "";
          
          function findBodyTextSearchTerm(fields) {
            for (var fieldIndex = 0; fieldIndex < fields.length; fieldIndex++) {
              var field = fields[fieldIndex];
              if (field.key === 'atex_desk_text' && field.values !== undefined) {
                return field.values[0];
              }
            }
            return "";
          }

          if (queryContainer.container.aspects.contentData.data !== undefined && queryContainer.container.aspects.contentData.data.fields !== undefined) {
            $rootScope.lastSearch = findBodyTextSearchTerm(queryContainer.container.aspects.contentData.data.fields);
            if ($rootScope.lastSearch.length === 0 && advancedAsFolderFilter && extraInfo && extraInfo.fullText) {
              $rootScope.lastSearch = findBodyTextSearchTerm(extraInfo.fullText.fields);
            }
            if ($rootScope.lastSearch.length === 0 && extraInfo && extraInfo.fullText && extraInfo.fullText.length > 0) {
              $rootScope.lastSearch = extraInfo.fullText;
            }
          }
          if (damid !== undefined) {
            response.data.damid = damid; // query executed from query-list-controller
          } else {
            response.data.damid = DamService.UUID(); // new query
          }
          response.data.container = queryContainer.container;
          // In case of dynamic query, save the latest atex_desk_version
          if (queryContainer.container.aspects.contentData.data.isDynamic === 'true') {
            $rootScope.dynamicQueries[response.data.damid] = '0';
            $rootScope.dynamicQueriesEx[response.data.damid] = '0';
            if (response.data.response.docs && response.data.response.numFound > 0) {
              var nextVersion = bigInt(response.data.response.docs[0].atex_desk_version).add(1).toString();
              if (configuration.getOnlyNewInDynQuery()) {
                var max_atex_desk_version = getMaxSolrVersion(response.data.response.docs);
                nextVersion = max_atex_desk_version.add(1).toString();
              }
              if (!dynQueryStartTs[response.data.damid]) {
                setDynQueryStartTs(response.data.damid, response.data.response.docs[0]);
              }

              $rootScope.dynamicQueries[response.data.damid] = nextVersion;
              $rootScope.dynamicQueriesEx[response.data.damid] = response.data.response.docs[0]._data.meta.originalCreationTime;
            }
          } else if (damid) {
            // The damid can be into dynQueryStartTs (i.e. if we change the nature of a query, removing dynamic flag)
            delete dynQueryStartTs[damid];
          }

          // set the solrQuery that will be used in case of dynamic search into DamDynamicQueriesService.addUpdateQuery
          response.data.container.aspects.contentData.data.solrQueryString = queryData.data.solr_query;

          // If we are refining a folder search, don't update 'back' advanced model
          var physicalPages = (queryData.data.physicalPages === "true");
          var skipUpdAdvSearchDlg = ((extraInfo && extraInfo.refiningFolderSearch !== undefined) || physicalPages);
          _setAdvSearchData(response.data, queryData.data, skipUpdAdvSearchDlg);

          if (physicalPages) {
            angular.copy(response.data.container.aspects.contentData.data, currentPhysicalPagesQuery);
          }

          if (extraInfo && extraInfo.type === 'atex.dam.standard.Folder') {
            if (extraInfo.fullText && typeof (extraInfo.fullText) === 'string') {
              response.data.isFullText = true;
              response.data.searchvalue = extraInfo.fullText;
              currentAdvQuery.fullText = extraInfo.fullText;
            }
          }
          $rootScope.$broadcast("dam:search", response.data, extraInfo && extraInfo.googleSearch);
          requestFaceting(queryData.data, configuration.getQueryFilterTrash(), extraInfo, !advancedAsFolderFilter, false);
          /*
          DamService.getFacetsValues(queryData.data, configuration.getQueryFilterTrash()).then(function (facetResults) {
            doFaceting(facetResults.data);
            if (!advancedAsFolderFilter) {
              // Advanced facet only if we are not refining folder
              DamService.getAdvancedFacets(queryData.data, null).then(function (facetResults) {
                if (extraInfo && !_isStillLastQuery(extraInfo.queryTs)) {
                  return $q.reject();
                }
                faceting(facetResults.data, true);
                $rootScope.$broadcast("dam:loading-facet:stop");
              }).then(null, function (error) {
                console.log('ERROR: Performing facet query:', error);
                $rootScope.$broadcast("dam:loading-facet:stop");
              });
            }
          }).then(null, function (error) {
            console.log('ERROR: Performing facet query:', error);
            $rootScope.$broadcast("dam:loading-facet:stop");
          });
           */
        });
      });
    });
  };

  /* Send the request to start faceting to the facet controller
   */
  function requestFaceting (query, filter, extraInfo, advancedFacets, fullText, childrenQueryString) {
    facetSettings = {query:query,filter:filter,extraInfo:extraInfo,advancedFacets:advancedFacets,fullText:fullText,childrenQueryString:childrenQueryString};

    $rootScope.$broadcast("dam:loading-facet:execute");
  }

  /*
   * this is the way to return the fq string for faceting on standard fields
   * this is used when you need to retrieve fq string for "direct" faceting
   * on object fields
   */
  var getFilterQueryString = function (filterQuery) {
    var filterQueryString = '';
    for (var fieldCode in filterQuery) {
      var fieldName = fieldCode.substring(0, fieldCode.indexOf('@@'));
      var facetField = filterQuery[fieldCode];
      if (facetField.isOnChild) {
        filterQueryString += '+_query_:"{!parent%20which=\'contentType_atex_desk_s:parentDocument\'}+' + fieldName;
        if (facetField.isDate) {
          filterQueryString += ':[' + facetField.value + " TO " + facetField.value + facetField.gap + '}"';
        } else {
          filterQueryString += ':(\\"' + facetField.value + '\\")"';
        }
      } else {
        filterQueryString += '+' + fieldName;
        if (facetField.isDate) {
          filterQueryString += ':[' + facetField.value + " TO " + facetField.value + facetField.gap + '}';
        } else {
          filterQueryString += ':("' + facetField.value + '")';
        }
      }
    }

    return filterQueryString;
  };


  /*
   * this is the way to return the fq string for faceting on children
   * objects' fields, where the fq condition should look something like:
   * +_query_:"{!child%20of='contentType_atex_desk_s:parentDocument'}+attributes_atex_desk_facet:(\"Internet\")"
   * so this is used when you need to retrieve the fq string for advanced
   * faceting on publication event fields
   */
  function getChildrenFilterQueryString(filterQuery) {
    var filterQueryString = '';

    for (var fieldCode in filterQuery) {
      var fieldName = fieldCode.substring(0, fieldCode.indexOf('@@'));
      var facetField = filterQuery[fieldCode];
      if (facetField.isOnChild) {
        filterQueryString += '+' + fieldName;
        if (facetField.isDate) {
          filterQueryString += ':[' + facetField.value + " TO " + facetField.value + facetField.gap + '}';
        } else {
          filterQueryString += ':("' + facetField.value + '")';
        }
      } else {
        filterQueryString += '+_query_:"{!child%20of=\'contentType_atex_desk_s:parentDocument\'}+' + fieldName;
        if (facetField.isDate) {
          filterQueryString += ':[' + facetField.value + " TO " + facetField.value + facetField.gap + '}"';
        } else {
          filterQueryString += ':(\\"' + facetField.value + '\\")"';
        }
      }
    }

    return filterQueryString;
  }

  // FaceResult class
  function FacetResult(fieldName, value, Score, isOnChild, isDate, gap, selected) {
    this.fieldName = fieldName;
    this.value = value;
    this.score = Score;
    this.isOnChild = isOnChild;
    this.isDate = isDate;
    this.gap = gap;
    this.selected = selected;

    var contentTypes = [
      'article',
      'image',
      'page',
      'video',
      'graphic',
      'collection',
      'tweet',
      'instagram',
      'document',
      'liveblog'
    ];
    var table = $translate.getTranslationTable();
    if (_.contains(contentTypes, value)) {
      this.label = table['__' + value.toUpperCase() + '_LABEL__'];
    } else {
      this.label = value;
    }

    // Check on markas fields
    if (fieldName==='tag_dimension.markas-colorcoding_ss') {
      var colorBudget = _.find(markAsColors, function(col) {
        return col.id===value;
      });
      if (colorBudget) {
        this.label = '<div class="color-coding-color-box" style="background: ' + colorBudget.color + '"></div> ' + colorBudget.label;
        this.isHtmlLabel = true;
      }
    } else if (fieldName==='tag_dimension.markas-iconcoding_ss') {
      if (markAsIcons) {
        this.ratingRange = markAsIcons.range;
        this.ratingIcons = [markAsIcons.icon, markAsIcons.selected];
        this.currentRating = value;
        this.ratingDisabled = true;
        this.isRating = true;
      }
    }

    // Check status field
    if (fieldName==='content_status_id_s') {
      var statusBudget = _.find(statusList, function(_status) {
        return _status.statusID===value;
      });
      if (statusBudget) {
        this.label = '<div class="color-coding-color-box" style="background: ' + statusBudget.color + '"></div> ' + statusBudget.name;
        this.isHtmlLabel = true;
      }
    }

    // Relevance field label
    if (fieldName==='relevance_atex_desk_sms') {
      if (markAsIcons) {
        this.ratingRange = markAsIcons.range;
        this.ratingIcons = [markAsIcons.icon, markAsIcons.selected];
        this.currentRating = value;
        this.ratingDisabled = true;
        this.isRating = true;
      }
    }

    if (fieldName==='homepage_atex_desk_sms') {
      if(value){
        var a = value.split('.');
        var s = a[0];
        var n = a[a.length-2];
        this.label = s + ' ' + n;
        this.isHtmlLabel = true;
      }
    }

    if (fieldName === 'tag_dimension.partition_ss') {
      this.label = table['__' + value.toUpperCase() + '_PARTITION__'];
      if (!this.label) {
        this.label = value;
      }
    } else if (fieldName === 'tag_dimension.markas-colorcoding_ss') { // Check on markas fields
      var color = _.find(markAsColors, function (col) {
        return col.id === value;
      });
      if (color) {
        this.label = '<div class="color-coding-color-box" style="background: ' + color.color + '"></div> ' + color.label;
        this.isHtmlLabel = true;
      }
    } else if (fieldName === 'tag_dimension.markas-multiiconcoding_ss') {
      var micon = _.find(markAsMicons, function (mic) {
        return mic.id === value;
      });
      if (micon) {
        this.label = '<i class="' + micon.icon + '"/> ' + micon.label;
        this.isHtmlLabel = true;
      }
    } else if (fieldName === 'tag_dimension.markas-iconcoding_ss') {
      if (markAsIcons) {
        this.ratingRange = markAsIcons.range;
        this.ratingIcons = [markAsIcons.icon, markAsIcons.selected];
        this.currentRating = value;
        this.ratingDisabled = true;
        this.isRating = true;
      }
    }

    // Check status field
    if (fieldName === 'content_status_id_s') {
      var status = _.find(statusList, function (_status) {
        return _status.statusID === value;
      });
      if (status) {
        this.label = atex.dam.AngularUtils.statusLabel(status);
        this.isHtmlLabel = true;
      }
    }

    // Check status field
    if (fieldName === 'web_status_id_s') {
      var webStatus = _.find(webStatusList, function (_status) {
        return _status.statusID === value;
      });
      if (webStatus) {
        this.label = atex.dam.AngularUtils.statusLabel(webStatus);
        this.isHtmlLabel = true;
      }
    }

    // Check attributes field
    if (fieldName === 'content_status_attribute_ss') {
      var attribute = _.find(attributesList, function (_attribute) {
        return _attribute.attributeID === value;
      });
      if (attribute) {
        this.label = atex.dam.AngularUtils.attributeLabel(attribute);
        this.isHtmlLabel = true;
      }
    }

    var uniqueKey = this.value;
    /*
     * this is needed because in case of a date object the timestamp will
     * change as far as the user clicks on an item and re-does the query
     */
    if (isDate) {
      uniqueKey = uniqueKey.substring(0, uniqueKey.indexOf('T'));
    }
    this.identifier = uniqueKey;
  }

  function getKeyValuesMapFromRangeCountsArray(countsArray) {
    var keyValue = {};
    (countsArray || []).forEach(function (field, index) {
      if (index % 2 === 0 && countsArray[index + 1] !== undefined) {
        // even index
        keyValue[field] = countsArray[index + 1];
      }
    });
    return keyValue;
  }

  var facetDates = function (facet_ranges, fieldName, isOnChild) {
    var datesFacets = [];
    datesFacets.tick = configuration.getFacetRepeatLimit();
    var keyValuesMap = getKeyValuesMapFromRangeCountsArray(facet_ranges.counts || []);
    Object.keys(keyValuesMap).sort().reverse().forEach(function (field) {
      var dcount = keyValuesMap[field];
      var dfacet = new FacetResult(fieldName, field, dcount, isOnChild, true, facet_ranges['gap'], false);
      datesFacets.push(dfacet);
    });
    return datesFacets;
  };

  var _addFaceting = function (searchResponseData, isOnChild) {
    var fcresults = searchResponseData.facet_counts;
    var fieldName;
    if (fcresults !== undefined) {
      if (fcresults.hasOwnProperty('facet_fields')) {
        for (fieldName in fcresults.facet_fields) {
          var fieldFacets = [];
          fieldFacets.tick = configuration.getFacetRepeatLimit();
          var facet_fields = fcresults.facet_fields[fieldName];
          for (var i = 0; i < facet_fields.length; i += 2) {
            var value = fcresults.facet_fields[fieldName][i];
            var count = fcresults.facet_fields[fieldName][i + 1];
            var facet = new FacetResult(fieldName, value, count, isOnChild, false, null, false);
            fieldFacets.push(facet);
          }
          if (!fieldFacets.tick) {
            fieldFacets.tick = fieldFacets.length;
          }
          facets.push(fieldFacets);
        }
      }

      if (fcresults.hasOwnProperty('facet_ranges')) {
        for (fieldName in fcresults.facet_ranges) {
          var datesFacets = facetDates(fcresults.facet_ranges[fieldName], fieldName, isOnChild);
          if (!datesFacets.tick) {
            datesFacets.tick = datesFacets.length;
          }
          facets.push(datesFacets);
        }
      }
    }
  };

  var executeFaceting = function () {
    var queryData = {};
    queryData['solr_query'] = $rootScope.lastSolrQuery;
    queryData['reverse_query'] = $rootScope.reverseSolrQuery;
    queryData['includeTrash'] = $rootScope.includeTrash;

    if ($rootScope.lastAdvQueryData && $rootScope.lastAdvQueryData.isDynamic === 'true') {
      queryData['isDynamic'] = $rootScope.lastAdvQueryData.isDynamic;
    }

    if ($rootScope.lastAdvQueryData && $rootScope.lastAdvQueryData.physicalPages === 'true') {
      queryData['physicalPages'] = $rootScope.lastAdvQueryData.physicalPages;
    }

    if ($rootScope.lastAdvQueryData) {
      queryData['onlyLatest'] = $rootScope.lastAdvQueryData.onlyLatest;
    }
    $rootScope.$broadcast("dam:loading-facet:start");
    DamService.getResults(queryData, 0, facetFilterQueryString).then(function (response) {
      if (refreshSearch.container) {
        response.data.container = refreshSearch.container;
      }
      $rootScope.$broadcast("dam:search", response.data);
      var childrenQueryString = getChildrenFilterQueryString(facetFilterQuery);

      requestFaceting(queryData, facetFilterQueryString, undefined, true, false, childrenQueryString);
      /*
      DamService.getFacetsValues(queryData, facetFilterQueryString).then(function (facetResults) {
        doFaceting(facetResults.data);
        DamService.getAdvancedFacets(queryData, childrenQueryString).then(function (facetResults) {
          faceting(facetResults.data, true);
          $rootScope.$broadcast("dam:loading-facet:stop");
        }).then(null, function (error) {
          console.log('ERROR: Performing facet query:', error);
          $rootScope.$broadcast("dam:loading-facet:stop");
        });
      }).then(null, function (error) {
        console.log('ERROR: Performing facet query:', error);
        $rootScope.$broadcast("dam:loading-facet:stop");
      });

       */
    });
  };

  var getEntryTs = function(entry) {
    if (configuration.getOnlyNewInDynQuery()) {
      return atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/p.ContentMetadata/data/creationTime');
    } else {
      return atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/p.ContentMetadata/data/modifiedTime');
    }
  };

  var setDynQueryStartTs = function(searchDamId, entry) {
    dynQueryStartTs[searchDamId] = getEntryTs(entry) || 0;
  };

  return {
    getCurrentAdvQuery: function () {
      return currentAdvQuery;
    },

    clearCurrentAdvQuery: function () {
      clearCurrentAdvQuery();
    },

    getCurrentPhysicalPagesQuery: function () {
      return currentPhysicalPagesQuery;
    },

    getFacets: function () {
      return facets;
    },

    getFacetFilterQuery: function () {
      return facetFilterQuery;
    },

    simpleSearch: function (queryString) {
      $rootScope.$broadcast("dam:resetViewMode");

      var ts = Date.now();
      _setLastQueryStartTs(ts);
      var extraInfo = {
        queryTs: ts
      };
      var physicalPages = currentAdvQuery && (currentAdvQuery.physicalPages === "true");
      var isAdvanced = currentAdvQuery && currentAdvQuery.fields;

      if (!isAdvanced || physicalPages) {
        $state.go('list');
        currentAdvQuery.fullText = queryString;
        currentAdvQuery.sortValue = $rootScope.damSortData.currentSortValue;
        currentAdvQuery.sortOrderValue = $rootScope.damSortData.currentSortOrderValue;
        $('#searchvalueinput').val(queryString);  // TODO: check  this, thanks!

        resetFaceting();
        $rootScope.$broadcast("dam:initSearch");

        $rootScope.lastSearch = queryString;
        refreshSearch = queryString;
        lastExtraInfo = undefined;
        $timeout(function () {
          fullText(queryString, extraInfo);
        });
      } else {
        // Perform an advanced + googleSearch
        if (currentAdvQuery && currentAdvQuery.fields) {
          if (queryString) {
            var found = currentAdvQuery.fields.find(function (field) {
              return field.key === 'atex_desk_text';
            });
            if (found) {
              found.values[0] = queryString;
            } else {
              currentAdvQuery.fields.push({
                key: "atex_desk_text",
                subQuery: false,
                type: "STRING",
                values: [queryString]
              });
            }
          } else {
            // Remove 'atex_desk_text' field
            var foundIdx = currentAdvQuery.fields.findIndex(function (field) {
              return field.key === 'atex_desk_text';
            });
            if (foundIdx >= 0) {
              currentAdvQuery.fields.splice(foundIdx, 1);
            }
          }
          var searchCopy = {
            container: {
              aspects: {
                contentData: {
                  data: angular.copy(currentAdvQuery)
                }
              }
            }
          };

          extraInfo.googleSearch = queryString;
          _runQueryContainer(searchCopy, extraInfo);
        }
      }
    },

    advancedSearch: function (query, extraInfo) {
      var query2Execute = angular.copy(query);
      // reset query string
      query2Execute.solrQueryString = undefined;
      $timeout(function () {
        if (query2Execute.physicalPages === "true") {
          query2Execute.name = calcPhysicalPagesQueryName(query2Execute);
        } else if (query.budgetView){
          query2Execute.name = calcQueryNameBudget(query2Execute);
          //delete query2Execute.budgetView;
        }else{
          query2Execute.name = calcQueryName(query2Execute);
        }
        query2Execute._type = "atex.dam.standard.Query";
        var queryContainer = {
          'container': {
            'aspects': {
              'contentData': {
                'data': query2Execute
              }
            }
          }
        };
        _runQueryContainer(queryContainer, extraInfo);
      });
    },

    runQueryContainer: function (queryContainer, extraInfo) {
      var queryContainerCopy = JSON.parse(JSON.stringify(queryContainer));
      delete queryContainerCopy.container.aspects.contentData.data['types_element_types'];
      _runQueryContainer(queryContainer, extraInfo);
    },

    refresh: function () {
      if (refreshSearch === undefined) {
        return;
      }
      if (refreshSearch.damid) {
        // Clear the "yellow background" on refresh
        var isDyn = atex.onecms.ObjectUtils.getByPath(refreshSearch, 'container/aspects/contentData/data/isDynamic');
        if (isDyn) {
          delete dynQueryStartTs[refreshSearch.damid];
        }
      }
      currentAdvQuery.sortValue = $rootScope.damSortData.currentSortValue;
      currentAdvQuery.sortOrderValue = $rootScope.damSortData.currentSortOrderValue;
      //resetFaceting();
      $rootScope.$broadcast("dam:initSearch", lastExtraInfo);
      $timeout(function () {
        if (refreshSearch === undefined || refreshSearch.container === undefined) {
          if (!facetFilterQueryString) {
            fullText(refreshSearch);
          } else {
            executeFaceting();
          }
        } else {
          var fq = facetFilterQueryString;
          if (lastExtraInfo && lastExtraInfo.advancedAsFolderFilter) {
            fq += lastExtraInfo.advancedAsFolderFilter;
          }
          $rootScope.$broadcast("dam:loading-facet:start");
          DamService.getResults(advQueryData, 0, fq).then(function (response) {
            // Set new dynQueryStartTs for the dyn query
            if (advQueryData.isDynamic === "true" && refreshSearch.damid) {
              setDynQueryStartTs(refreshSearch.damid, response.data.response.docs[0]);
            }

            response.data.damid = refreshSearch.damid;
            response.data.container = refreshSearch.container;
            // If we are refining a folder with advanced, don't update 'back' advanced model
            var physicalPages = (currentAdvQuery.physicalPages === "true");
            var skipUpdAdvSearchDlg = ((lastExtraInfo && lastExtraInfo.refiningFolderSearch !== undefined) || physicalPages);
            _setAdvSearchData(response.data, advQueryData, skipUpdAdvSearchDlg);

            if (physicalPages) {
              angular.copy(response.data.container.aspects.contentData.data, currentPhysicalPagesQuery);
            }

            _initFaceting(response.data);
            response.data.isFaceting = true;
            $rootScope.$broadcast("dam:search", response.data);
            var childrenQueryString = getChildrenFilterQueryString(facetFilterQuery);
            requestFaceting(advQueryData, fq, undefined, (!lastExtraInfo || !lastExtraInfo.advancedAsFolderFilter), false, childrenQueryString);
            /*DamService.getFacetsValues(advQueryData, fq).then(function (facetResults) {
              doFaceting(facetResults.data);

              if (!lastExtraInfo || !lastExtraInfo.advancedAsFolderFilter) {
                // Advanced facet only if we are not refining folder
                DamService.getAdvancedFacets(advQueryData, childrenQueryString).then(function (facetResults) {
                  faceting(facetResults.data, true);
                  $rootScope.$broadcast("dam:loading-facet:stop");
                }).then(null, function (error) {
                  console.log('ERROR: Performing facet query:', error);
                  $rootScope.$broadcast("dam:loading-facet:stop");
                });
              }
            }).then(null, function (error) {
              console.log('ERROR: Performing facet query:', error);
              $rootScope.$broadcast("dam:loading-facet:stop");
            });

             */
          });
        }
      });
    },

    updateSearch: function (contentIds) {
      return _updateSearch(contentIds);
    },

    setAdvSearchData: function (searchResponseData) {
      return _setAdvSearchData(searchResponseData);
    },

    facetByItem: function (fieldName, item, action) {
      $rootScope.$broadcast("dam:clearPreviewPanel");
      $state.go('list');
      if (item === undefined) {
        return;
      }

      if (action === 'remove') {
        delete facetFilterQuery[fieldName + '@@' + item.identifier];
      } else {
        facetFilterQuery[fieldName + '@@' + item.identifier] = (item);
      }

      facetFilterQueryString = getFilterQueryString(facetFilterQuery);

      executeFaceting();

    },

    getFacetRepeatStep: function () {
      return configuration.getFacetRepeatStep();
    },

    setLastQueryStartTs: function (ts) {
      _setLastQueryStartTs(ts);
    },

    isStillLastQuery: function (ts) {
      return !ts || _isStillLastQuery(ts);
    },

    initFaceting: function (searchResponseData) {
      return _initFaceting(searchResponseData);
    },
    addFaceting: function (searchResponseData, isOnChild ) {
      return _addFaceting(searchResponseData, isOnChild);
    },
    getFacetSettings: function () {
      return facetSettings;
    },
    getDynQueryStartTs: function(queryId) {
      return dynQueryStartTs[queryId];
    },
    setDynQueryStartTs: function(searchDamId, entry) {
      return setDynQueryStartTs(searchDamId, entry);
    },
    isEntryNew: function(searchDamId, entry) {
      var lastTs = dynQueryStartTs[searchDamId];
      if (!lastTs) {
        return false;
      }
      return getEntryTs(entry) > lastTs;
    }

  };

}]);
